/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.quality.rpc.SelfServeRpc
 */
import * as References from './SelfServeRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.quality.rpc.SelfServeRpc#getSearchRequestForCollection
 */
export const GET_SEARCH_REQUEST_FOR_COLLECTION_QUERY_FIELD_NAME = 'com_hubspot_marketplace_quality_rpc_SelfServeRpc_getSearchRequestForCollection';
export const GET_SEARCH_REQUEST_FOR_COLLECTION_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SEARCH_REQUEST_FOR_COLLECTION_QUERY_FIELD_NAME,
  args: ['collectionId', 'published', 'language'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getSearchRequestForCollectionRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.quality.rpc.SelfServeRpc#getAllPublishedCollections
 */
export const GET_ALL_PUBLISHED_COLLECTIONS_QUERY_FIELD_NAME = 'com_hubspot_marketplace_quality_rpc_SelfServeRpc_getAllPublishedCollections';
export const GET_ALL_PUBLISHED_COLLECTIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ALL_PUBLISHED_COLLECTIONS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getAllPublishedCollectionsRpc, {
      timeout: ctx.timeout
    });
  }
});